import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({
  title = 'ADCORE CONSULTING - Printing Products',
  description = 'ADCORE CONSULTING offers top-notch printing services, bringing your ideas to life with quality and care.',
  keywords = 'printing services, Adcore Consulting, printing products, custom prints, business cards, Lagos printing, Nigeria printing',
  url = 'https://adcoreconsulting.com',
  image = '%PUBLIC_URL%/logo.png',
}) => {
  return (
    <Helmet>
      {/* General SEO */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Adcore Consulting" />
      <link rel="canonical" href={url} />

      {/* Open Graph for social media */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter Card for Twitter preview */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:creator" content="@adcoreconsulting" />

      {/* Favicons for different platforms */}
      <link rel="icon" href="%PUBLIC_URL%/favicon.ico" />
      <link rel="apple-touch-icon" href="%PUBLIC_URL%/logo.png" />
    </Helmet>
  );
};

export default SEO;
